const NotificationWorkFlowMapping = (api: any)=>({
    getNotificationWorkflowMappings: (findOptions:any) =>
        api.post('/notificationWorkflowMap/searchNotificationWorkflowMap.php', {},findOptions),
    createNotificationWorkflowMappings: (payload: {categoryIds: number[], stateIds:number[]})=>
        api.post('/notificationWorkflowMap/createNotificationWorkflowMap.php',{}, payload),
    deleteNotificationWorkflowMappings: (stateId: number, categoryId:number)=>
        api.remove('/notificationWorkflowMap/deleteNotificationWorkflowMap.php',{}, {stateId, categoryId}),
});




export default NotificationWorkFlowMapping;